module.exports = __webpack_public_path__ + "img/black-2.d3126e8d.png";